'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  selectionPrompt: 'SELECTION_PROMPT',
  providerChanged: 'PROVIDER_CHANGED',
  compareProviders: 'COMPARE_PROVIDERS',
  learnMoreAlert: 'LEARN_MORE_ALERT'
};